import Tag from 'components/Tag'
import { otherFeaturesBaseStyle } from 'components/features-page/DesktopFeaturesPage'
import FeatureText from 'components/features-page/FeatureText'
import { useStaticQuery, graphql } from 'gatsby'
import gaugeIcon from 'images/gauge-icon.svg'
import globeIcon from 'images/globe-icon.svg'
import hotspotIcon from 'images/hotspot-icon.svg'
import memeIcon from 'images/meme-icon.svg'
import refreshIcon from 'images/refresh-icon.svg'
import targetIcon from 'images/target-icon.svg'
import { ReactElement } from 'react'
import { Flex, Grid } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'

export default function OtherFeatures(): ReactElement {
  const data = useStaticQuery<Queries.OtherFeaturesQuery>(graphql`
    query OtherFeatures {
      directus {
        desktop_page {
          strings {
            languages_code {
              code
            }
            automatic_updating
            automatic_updating_subtitle
            custom_dns_support
            custom_dns_support_subtitle
            meme_friendly
            meme_friendly_subtitle
            other_features
            packet_size
            packet_size_subtitle
            secure_hotspot
            secure_hotspot_subtitle
            tcp_socket_subtitle
            tcp_socket_termination
          }
        }
      }
    }
  `)

  const otherFeaturesData = getEnglishStrings(data.directus?.desktop_page?.strings)

  return (
    <Flex sx={{ flexDirection: 'column', gap: '4.8rem' }}>
      <Tag title={otherFeaturesData?.other_features ?? ''} />
      <Grid columns={[1, 3, 3]} sx={otherFeaturesBaseStyle}>
        <FeatureText
          icon={targetIcon}
          text={otherFeaturesData?.tcp_socket_termination ?? ''}
          subtitle={otherFeaturesData?.tcp_socket_subtitle}
          href={'/features/tcp-socket-termination/'}
        />
        <FeatureText
          icon={gaugeIcon}
          text={otherFeaturesData?.packet_size ?? ''}
          subtitle={otherFeaturesData?.packet_size_subtitle}
          href={'/features/packet-size/'}
        />
        <FeatureText
          icon={hotspotIcon}
          text={otherFeaturesData?.secure_hotspot ?? ''}
          subtitle={otherFeaturesData?.secure_hotspot_subtitle}
          href={'/features/secure-hotspot/'}
        />
        <FeatureText
          icon={refreshIcon}
          text={otherFeaturesData?.automatic_updating ?? ''}
          subtitle={otherFeaturesData?.automatic_updating_subtitle}
          href={'/features/update-channels/'}
        />
        <FeatureText
          icon={globeIcon}
          text={otherFeaturesData?.custom_dns_support ?? ''}
          subtitle={otherFeaturesData?.custom_dns_support_subtitle}
          href={'/features/flexible-dns/'}
        />
        <FeatureText
          icon={memeIcon}
          text={otherFeaturesData?.meme_friendly ?? ''}
          subtitle={otherFeaturesData?.meme_friendly_subtitle}
        />
      </Grid>
    </Flex>
  )
}
